module.exports = __webpack_public_path__ + "img/preview-label.6c5bd5af.png";